import { getVideoJsComponent } from "./utils";

import type { THEOPlayerRuntime } from "./theoplayerRuntime";
import type Player from "video.js/dist/types/player";

export const getSpacingElement = (runtime: THEOPlayerRuntime) => {
  const VideoJSComponent = getVideoJsComponent("Component", runtime);

  class SpacingElement extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    createEl() {
      const el = super.createEl("div", {
        className: "vjs-custom-spacing",
      });
      return el;
    }
  }

  return SpacingElement;
};
